define('evicommon/spf/filter.adapter',['require','exports','module','../state/param.adapter','underscore'],function(require, exports, module){
  var ParamAdapter = require('../state/param.adapter');
  var _            = require('underscore');

  var FilterAdapter = ParamAdapter.extend({

    serializeModel: function() {
      var data    = this.model.toJSON(),
          options = this.options;

      _.each(options.format, function(fn, key) {
        if (data[key]) {
          fn.call(this, data[key], this.model, data, key);
        }
      }, this);

      return data;
    }

  });

  module.exports = FilterAdapter;
});
